module.exports = __webpack_public_path__ + "static/media/IMG-2.d24d5d52.jpg";